import React, { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Copy, Check, EnvelopeSimple } from "@phosphor-icons/react";

export function BulkEmailList({ professionals }) {
  const [copied, setCopied] = useState(false);
  const emails = [...new Set(
    professionals.filter(u => u.status === "approved" && u.email).map(u => u.email.trim().toLowerCase())
  )];
  const text = emails.join(", ");

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = text; document.body.appendChild(ta); ta.select();
      document.execCommand("copy"); ta.remove();
    }
    setCopied(true);
    toast.success(`${emails.length} email copiate negli appunti`);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="kpi-card mt-6" data-testid="bulk-email-section">
      <div className="flex items-center justify-between gap-3 flex-wrap mb-3">
        <div className="flex items-center gap-2">
          <EnvelopeSimple size={20} weight="duotone" />
          <h3 className="font-display text-lg font-semibold">Email per comunicazioni massive</h3>
          <span className="text-xs text-muted-foreground" data-testid="bulk-email-count">({emails.length})</span>
        </div>
        <Button size="sm" onClick={copy} disabled={!emails.length} data-testid="bulk-email-copy-btn">
          {copied ? <Check size={14} className="mr-1" /> : <Copy size={14} className="mr-1" />}
          {copied ? "Copiato!" : "Copia tutto"}
        </Button>
      </div>
      <div
        className="text-sm font-mono bg-slate-50 border rounded-md p-3 break-all select-all max-h-48 overflow-y-auto"
        data-testid="bulk-email-text"
      >
        {text || "Nessun professionista attivo."}
      </div>
    </div>
  );
}
